import { render, staticRenderFns } from "./KeywordPlannerCompetitionColumn.vue?vue&type=template&id=021b9d94"
import script from "./KeywordPlannerCompetitionColumn.vue?vue&type=script&lang=js"
export * from "./KeywordPlannerCompetitionColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports